import RemoteComponent from './components/RemoteComponent';
import { PbRenderElementPlugin } from '@whalecloud/page-builder-core/utils/types';

export default (): PbRenderElementPlugin => ({
  name: 'remoteComponent',
  pluginComponent: RemoteComponent,
});
